import { render, staticRenderFns } from "./RTaskDialog.vue?vue&type=template&id=30cefa04&scoped=true&"
import script from "./RTaskDialog.vue?vue&type=script&lang=js&"
export * from "./RTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cefa04",
  null
  
)

export default component.exports